export default __webpack_public_path__ + "static/media/Group 1413.893221b8.png";